import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logoAniMemo512.png'


const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-1" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col items-center mt-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-20 h-20",
  alt: "Logo AniMemo",
  src: _imports_0
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " Judul berita ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " link berita ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " snippet isi berita ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " gbr berita (gambar harus memiliki aspek rasio 4:3, bisa diedit di canva) ", -1)
const _hoisted_9 = { class: "text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputTeks = _resolveComponent("InputTeks")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.pengguna?.jenisPengguna?.admin || _ctx.pengguna?.jenisPengguna?.editor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createVNode(_component_InputTeks, {
            onInputBerubah: _ctx.judulBerubah,
            id: "input-judul"
          }, null, 8, ["onInputBerubah"]),
          _hoisted_6,
          _createVNode(_component_InputTeks, {
            onInputBerubah: _ctx.linkBerubah,
            id: "input-link"
          }, null, 8, ["onInputBerubah"]),
          _hoisted_7,
          _createVNode(_component_InputTeks, {
            onInputBerubah: _ctx.isiBerubah,
            lebarFull: "",
            area: "",
            id: "input-link"
          }, null, 8, ["onInputBerubah"]),
          _hoisted_8,
          _createElementVNode("input", {
            class: "text-white",
            type: "file",
            accept: "image/*",
            onChange: _cache[0] || (_cache[0] = (ev) => {_ctx.simpanGbr(ev)}),
            id: "file-input"
          }, null, 32),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "bg-red-500 p-5 mt-5 rounded-md",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadBerita && _ctx.uploadBerita(...args)))
            }, " upload berita ")
          ]),
          _createElementVNode("p", _hoisted_9, " admin animemo versi: " + _toDisplayString(_ctx.versi), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}